import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type PageButtonProps = {
  page: number | string;
  onClick: (page: number) => void;
  isCurrent?: boolean;
  isDisabled?: boolean;
};

export const PageButton: FC<PageButtonProps> = ({ page, onClick, isCurrent }) => {
  const isDisabled = typeof page !== 'number';

  return (
    <li>
      <button
        type='button'
        aria-current={isCurrent ? 'page' : undefined}
        aria-label={isCurrent ? `Page ${page}` : `Go to page ${page}`}
        data-page={page}
        data-current={isCurrent}
        aria-hidden={isDisabled}
        disabled={isDisabled}
        className={twMerge(
          'flex justify-between items-center rounded-lg p-2 px-3 py-1.5 text-sm font-medium text-quaternary-500',
          isCurrent ? 'bg-primary-hover text-secondary-700' : 'not-disabled:hover:bg-primary-hover not-disabled:hover:text-secondary-700',
          'aria-hidden:items-end',
          'motion-safe:transition-colors motion-safe:duration-300 motion-reduce:transition-none'
        )}
        onClick={isDisabled ? undefined : () => onClick(page - 1)}
      >
        {page}
      </button>
    </li>
  );
};
